import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import styles from "./Map.module.css";
import MyComponent from "./MyComponent";
import ChangeCenter from "./ChangeCenter";
import { tempToColor } from "../../utils/helpers";
function Map({ tempColor, getPosition, lat, lng, setPosition }) {
  if (lat === undefined || lng === undefined) return;
  return (
    <>
      <MapContainer
        style={{
          transition: ".5s",
          backgroundColor: `${tempToColor(tempColor)}`,
        }}
        className={styles.map}
        center={[lat, lng]}
        zoom={13}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lng]}>
          <Popup>
            Latitude {lat.toFixed(5)}
            <br /> Longitude {lng.toFixed(5)}
          </Popup>
        </Marker>
        <MyComponent setPosition={setPosition}></MyComponent>
        <ChangeCenter lat={lat} lng={lng}></ChangeCenter>
        <button className={styles.button} onClick={getPosition}>
          Get Current Location
        </button>
      </MapContainer>
    </>
  );
}

export default Map;
